import React, { useRef, useCallback, useState } from 'react';
// import withAppInsights from '../.../appInsights.js';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { contextStyles } from './contextStyles';
import cn from 'clsx';
import { useSelector } from 'react-redux';
import { getNodeData } from '../../../store';
interface menuProps {
  data: any;
  close: any;
  position: any;
  type: 'nodeMenu' | 'edgeMenu' | 'paneMenu';
}

const getAttribute = (data: any, attribute: string) =>
  (data && data.hasOwnProperty('data') && data.data.hasOwnProperty(attribute) && data.data[attribute]) || '';

const JSONContextMenu = ({ data, close, position, type }: menuProps) => {
  const allComponentsData = useSelector(getNodeData);
  const classes = contextStyles();
  const label = getAttribute(data, 'label');
  return (
    <>
      {type === 'nodeMenu' && (
        <div
          className={classes.contextMenu}
          style={{
            top: position.y - 45,
            left: position.x,
          }}
        >
          <ul className={classes.options}>
            <>
              {label != '' && (
                <>
                  <li className={cn(classes.header)}>{label}
                  {/* <br/>({data['componentType']}) */}
                  </li>
                  {data['linkType'] !== 'localAccountSignIn' && (
                    <li
                      className={classes.active}
                      onClick={() => {
                        close({ action: 'edit', type: 'node', data: data });
                      }}
                    >
                      Edit Node
                    </li>
                  )}
                  {!data['linkId'] && (
                    <li
                      className={classes.active}
                      onClick={() => {
                        close({ action: 'delete', type: 'node', data: data });
                      }}
                    >
                      Delete Node
                    </li>
                  )}
                </>
              )}
            </>
          </ul>
        </div>
      )}
      {type === 'edgeMenu' && !allComponentsData[data['target']]['linkId'] && (
        <div
          className={classes.contextMenu}
          style={{
            top: position.y - 45,
            left: position.x,
          }}
        >
          <ul className={classes.options}>
            <>
              <li className={cn(classes.header)}>Edge </li>
              <li
                className={classes.active}
                onClick={() => {
                  close({ action: 'delete', type: 'edge', data: data });
                }}
              >
                Delete Edge
              </li>
            </>
          </ul>
        </div>
      )}

      {/* {type === 'paneMenu' && (
        <>
          <li
            onClick={() => {
              close({ action: 'add', type: 'pane', data: data });
            }}
          >
            Add Node
          </li>
        </>
      )} */}
    </>
  );
};

//@ts-ignore
// export default withAITracking(reactPlugin, JSONContextMenu);
export default JSONContextMenu;
